import { render, staticRenderFns } from "./AuthorMedal.vue?vue&type=template&id=4fefcb3c&"
import script from "./AuthorMedal.vue?vue&type=script&lang=js&"
export * from "./AuthorMedal.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/youtube/yt-live-chat-author-medal-renderer.css?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports